<script setup lang="ts">
import type { Component } from 'vue';
import type { RouteLocationRaw } from 'vue-router';
import { RouterLink, useRoute, useRouter } from 'vue-router';

const { to } = defineProps<{
    to: RouteLocationRaw;
    icon?: Component;
    img?: string;
    title: string;
    comingSoon?: boolean;
    newFeature?: boolean;
}>();

const activeRoute = useRoute();
const router = useRouter();
const toName = router.resolve(to).name;
</script>

<template>
    <RouterLink
        :to="to"
        class="flex gap-x-2 p-3 rounded-lg transition-colors hover:bg-gray-200 items-center"
        :activeClass="
            activeRoute.name !== 'dashboard' && toName === 'dashboard'
                ? ''
                : 'text-primary-400 bg-gray-200 font-bold'
        "
    >
        <img v-if="img" :src="img" :alt="title" class="size-6 flex-shrink-0" />
        <component v-else :is="icon" class="size-6 flex-shrink-0" />
        <span v-text="title" class="flex-1" />
        <span
            v-if="newFeature"
            class="bg-primary-400 text-white rounded-md flex-shrink-0 px-1 font-bold py-0.5 text-caption-2"
        >
            {{ $t('generic.common_terms.new') }}
        </span>
        <FdxIconHistoryToggleOff
            v-if="comingSoon"
            class="text-gray-500 size-4"
        />
    </RouterLink>
</template>
